import comp from "./ResourceEdit";
export default comp;
